import React from 'react';
import i18n from 'i18next';
import Button from '@/Components/Button';
import Authenticated from '@/Layouts/Authenticated';
import ValidationErrors from '@/Components/ValidationErrors';
import {Head, Link, useForm, usePage} from '@inertiajs/inertia-react';
import ModuleCard from "@/Components/ModuleCard";

export default function AddModules() {
    const allModules = usePage().props.modules;
    let initiallySelectedModules = allModules.map(module => module.uuid); // select all modules available by default
    const {data, setData, post, processing, errors, reset} = useForm({
        modules: initiallySelectedModules
    });

    const submit = (e) => {
        e.preventDefault();
        toggleModules(); // run again here to ensure data is in sync with what's on page before sending
        post(route('organization.add-modules.store'));
    };

    function toggleModules() {
        const checkedModuleNodes = document.querySelectorAll("input[name='modules[]']:checked");
        setData('modules',
            Array.from(checkedModuleNodes, x => x.id));
    }

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            <Head title="Add Modules"/>
            <div className="outside-logo"></div>
            <div className="add-modules">
                <form onSubmit={submit}>
                    <div className="title">{i18n.t("add-modules.what-apps")}?</div>
                    <ValidationErrors errors={errors}/>
                    <div className="instructions">{i18n.t("add-modules.select-apps")}</div>
                    <div className="row modules">
                        {allModules.map(module =>
                            <div key={module.uuid} className="col-12 col-sm-4 mb-4">
                                <ModuleCard
                                    module={module}
                                    toggleModules={toggleModules}
                                    interactive={true}
                                    startingState={data.modules.includes(module.uuid)}
                                    useModuleSalesName={true}
                                ></ModuleCard>
                            </div>
                        )}
                    </div>

                    <div className="">
                        <Button className="w-100 btn btn-primary" processing={processing || data.modules.length === 0} dataTestid="add_modules-button-continue">
                            <span>{i18n.t("add-modules.continue")}</span><i className="far fa-chevron-right"></i>
                        </Button>
                    </div>
                </form>
            </div>
            <div className="step">
                <Link href={route('organization.add-address.show')} className="no-link">
                    <i className="fal fa-long-arrow-left"></i>
                </Link>
                <span>{i18n.t("add-modules.step")} 2 {i18n.t("add-modules.of")} 5</span>
            </div>
        </Authenticated>
    );
}
